import { useEffect, useState } from 'react'

// The page's clock for relative times ("5 minutes ago", local-time.js
// agoText): the current time, moved on about once a minute while anything
// reads it, by one timer for the whole page however many readers there are
// (a grid of course cards shares it). A reader starts at the current time.

const MINUTE = 60 * 1000

const readers = new Set()
let timer = null

const tick = () => {
  const now = Date.now()
  readers.forEach(read => read(now))
}

const subscribe = read => {
  readers.add(read)
  if (!timer) timer = setInterval(tick, MINUTE)
  return () => {
    readers.delete(read)
    if (!readers.size && timer) {
      clearInterval(timer)
      timer = null
    }
  }
}

export const useMinuteClock = () => {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => subscribe(setNow), [])
  return now
}
